export function TipeeeIcon() {
  return (
    <svg viewBox="0 0 234.79 136.57" version="1.1">
      <path
        d="m 214.09,136.53 -193.4,0.04 C 9.27,136.57 0.03,127.32 0,115.9 V 20.7 C 0,9.28 9.25,0.04 20.67,0.01 L 214.07,0 c 11.42,0 20.66,9.25 20.69,20.67 l 0.03,95.2 c -0.03,11.39 -9.27,20.63 -20.7,20.66 z"
        id="path1"
        fill="#fefdfd"
      />
      <path
        d="m 36.14,43.6 v -9.95 l 19.92,-6.38 0.01,16.33 h 10.29 l 0.01,14.08 H 56.08 v 19.27 c 0,3.69 -0.75,8.65 3.48,8.65 1.41,-0.01 4.76,-0.98 6.83,-1.83 l -0.01,13.86 c -3.26,1.3 -10.6,2.06 -13.1,2.05 -16.24,0 -16.79,-8.87 -17.09,-22.73 V 57.68 L 30.34,57.67 30.33,43.6 Z"
        fill="#d84759"
      />
      <path
        d="m 75.34,97.73 0.01,-14.17 4.53,0.01 V 57.7 l -4.53,-0.01 -0.01,-14.08 25.09,-0.02 0.01,39.92 5.19,0.01 -0.01,14.17 z M 90.05,16.78 c 7.48,-0.01 11.89,6.07 11.89,11.05 0,5.94 -4.23,10.94 -11.89,10.92 -6.82,-0.01 -11.68,-5.72 -11.7,-10.91 0.01,-5.01 4.13,-11.06 11.7,-11.06 z"
        fill="#d84759"
      />
      <path
        d="m 113.32,105.6 -0.01,-47.62 -4.53,-0.01 -0.01,-14.39 24.77,0.01 1.83,3.77 c 2.05,-1.51 6.6,-4.66 13.11,-4.64 16.89,0.01 25.53,12.98 25.54,28.35 0,17.21 -10.71,27.82 -24.66,27.82 -8.98,0 -13.32,-3.57 -14.07,-4.21 v 10.92 l 5.85,0.01 -0.01,14.17 -32.35,0.02 0.01,-14.17 z M 142.93,58 c -4.22,-0.01 -8.1,5.3 -7.68,13.86 0.01,7.35 3.7,12.98 7.8,12.97 4.53,0.01 7.69,-5.29 7.67,-13.52 0.01,-6.51 -3.01,-13.32 -7.79,-13.31 z"
        fill="#d84759"
      />
      <path
        d="m 190.48,75.18 c 7.7,0 12.89,5.3 12.88,11.46 0.01,6.07 -4.99,11.14 -12.87,11.16 -7.04,0 -12.34,-5.53 -12.35,-11.13 0.02,-5.42 4.54,-11.48 12.34,-11.49 z m -11.9,-53.13 h 25.87 V 42.6 l -5.72,27.26 h -14.3 L 178.57,42.6 Z"
        fill="#d84759"
      />
    </svg>
  );
}
